import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ShoppingBag, Menu, X, Search, Heart, User, LogOut, Shield } from 'lucide-react'
import { useCart } from '../context/CartContext'
import { useAuth } from '../context/AuthContext'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { cartCount } = useCart()
  const { user, isAdmin, logout } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  const isActive = (path) => location.pathname === path

  const handleLogout = () => {
    logout()
    navigate('/')
    setIsMenuOpen(false)
  }

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50" data-component-path="client/src/components/Navbar.jsx" data-component-line="15:4" data-component-id="client/src/components/Navbar.jsx:15:4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="16:6" data-component-id="client/src/components/Navbar.jsx:16:6">
        <div className="flex justify-between items-center h-20" data-component-path="client/src/components/Navbar.jsx" data-component-line="17:8" data-component-id="client/src/components/Navbar.jsx:17:8">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-component-path="client/src/components/Navbar.jsx" data-component-line="19:10" data-component-id="client/src/components/Navbar.jsx:19:10">
            <img 
              src="/files/logo.png"
              alt="Daisy Jewells Logo"
              className="h-16 w-auto object-contain"
              data-component-path="client/src/components/Navbar.jsx" data-component-line="20:12" data-component-id="client/src/components/Navbar.jsx:20:12"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-component-path="client/src/components/Navbar.jsx" data-component-line="36:10" data-component-id="client/src/components/Navbar.jsx:36:10">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors ${isActive('/') ? 'text-champagne-600' : 'text-gray-700 hover:text-champagne-500'}`}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="37:12" data-component-id="client/src/components/Navbar.jsx:37:12"
            >
              Home
            </Link>
            <Link 
              to="/shop" 
              className={`text-sm font-medium transition-colors ${isActive('/shop') ? 'text-champagne-600' : 'text-gray-700 hover:text-champagne-500'}`}
              data-component-path="client/src/components/Navbar.jsx" data-component-line="43:12" data-component-id="client/src/components/Navbar.jsx:43:12"
            >
              Shop
            </Link>
            <button className="text-gray-700 hover:text-champagne-500 transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="49:12" data-component-id="client/src/components/Navbar.jsx:49:12">
              <Search className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="50:14" data-component-id="client/src/components/Navbar.jsx:50:14" />
            </button>
            <button className="text-gray-700 hover:text-champagne-500 transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="52:12" data-component-id="client/src/components/Navbar.jsx:52:12">
              <Heart className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="53:14" data-component-id="client/src/components/Navbar.jsx:53:14" />
            </button>
            <Link to="/cart" className="relative text-gray-700 hover:text-champagne-500 transition-colors" data-component-path="client/src/components/Navbar.jsx" data-component-line="55:12" data-component-id="client/src/components/Navbar.jsx:55:12">
              <ShoppingBag className="w-5 h-5" data-component-path="client/src/components/Navbar.jsx" data-component-line="56:14" data-component-id="client/src/components/Navbar.jsx:56:14" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-champagne-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium" data-component-path="client/src/components/Navbar.jsx" data-component-line="58:16" data-component-id="client/src/components/Navbar.jsx:58:16">
                  {cartCount}
                </span>
              )}
            </Link>
            {user ? (
              <>
                {isAdmin && (
                  <Link
                    to="/admin"
                    className={`text-sm font-medium transition-colors flex items-center gap-1 ${isActive('/admin') ? 'text-champagne-600' : 'text-gray-700 hover:text-champagne-500'}`}
                  >
                    <Shield className="w-4 h-4" />
                    Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="text-sm font-medium text-gray-700 hover:text-champagne-500 transition-colors flex items-center gap-1"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className={`text-sm font-medium transition-colors flex items-center gap-1 ${isActive('/login') ? 'text-champagne-600' : 'text-gray-700 hover:text-champagne-500'}`}
              >
                <User className="w-4 h-4" />
                Login
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-component-path="client/src/components/Navbar.jsx" data-component-line="67:10" data-component-id="client/src/components/Navbar.jsx:67:10"
          >
            {isMenuOpen ? <X className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="71:29" data-component-id="client/src/components/Navbar.jsx:71:29" /> : <Menu className="w-6 h-6" data-component-path="client/src/components/Navbar.jsx" data-component-line="71:62" data-component-id="client/src/components/Navbar.jsx:71:62" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100" data-component-path="client/src/components/Navbar.jsx" data-component-line="77:10" data-component-id="client/src/components/Navbar.jsx:77:10">
            <div className="flex flex-col space-y-4" data-component-path="client/src/components/Navbar.jsx" data-component-line="78:12" data-component-id="client/src/components/Navbar.jsx:78:12">
              <Link 
                to="/" 
                className={`text-sm font-medium ${isActive('/') ? 'text-champagne-600' : 'text-gray-700'}`}
                onClick={() => setIsMenuOpen(false)}
                data-component-path="client/src/components/Navbar.jsx" data-component-line="79:14" data-component-id="client/src/components/Navbar.jsx:79:14"
              >
                Home
              </Link>
              <Link 
                to="/shop" 
                className={`text-sm font-medium ${isActive('/shop') ? 'text-champagne-600' : 'text-gray-700'}`}
                onClick={() => setIsMenuOpen(false)}
                data-component-path="client/src/components/Navbar.jsx" data-component-line="86:14" data-component-id="client/src/components/Navbar.jsx:86:14"
              >
                Shop
              </Link>
              <Link 
                to="/cart" 
                className={`text-sm font-medium ${isActive('/cart') ? 'text-champagne-600' : 'text-gray-700'}`}
                onClick={() => setIsMenuOpen(false)}
                data-component-path="client/src/components/Navbar.jsx" data-component-line="93:14" data-component-id="client/src/components/Navbar.jsx:93:14"
              >
                Cart ({cartCount})
              </Link>
              {user ? (
                <>
                  {isAdmin && (
                    <Link
                      to="/admin"
                      className={`text-sm font-medium ${isActive('/admin') ? 'text-champagne-600' : 'text-gray-700'}`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Admin Dashboard
                    </Link>
                  )}
                  <button
                    onClick={handleLogout}
                    className="text-sm font-medium text-gray-700 text-left"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className={`text-sm font-medium ${isActive('/login') ? 'text-champagne-600' : 'text-gray-700'}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className={`text-sm font-medium ${isActive('/signup') ? 'text-champagne-600' : 'text-gray-700'}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
